define('models/filter-list',['require','models/base/model','underscore','lib/utils'],function(require) {
    'use strict';

    var Model = require('models/base/model'),
        _ = require('underscore'),
        utils = require('lib/utils');

    var FilterList = Model.extend({
        urlPath: function() {
            return '/filters/' + this.get('type');
        },
        defaults: {
            type: 'test',
            items: []
        },

        parse: function(data) {
            return {
                items: data
            };
        },

        setFilter: function(filter) {
            this.filter = filter;
            filter.on('saveFilter', _.bind(this.saveFilter, this));
        },

        saveFilter: function(name, values) {
            var model = this;
            utils
                .post('/filters/' + this.get('type'), { name: name, value: JSON.stringify(values) })
                .success(function(obj) {
                    var items = model.get('items');
                    items.push(obj);
                    model.trigger('render');
                });
        },

        showFilter: function() {
            this.filter.trigger('openFilter');
        },

        selectFilter: function(id) {
            var filter = this.filter;

            var selected = _.findWhere(this.get('items'), { id: id });

            try {
                filter.setFilter(JSON.parse(selected.value));
            } catch(e) {
                console.error('Saved filter parse error', e);
            }

        },

        deleteFilter: function(id) {
            var model = this;
            utils
                .delete('/filters/' + this.get('type'), { id: id })
                .success(function() {
                    var items = model.get('items');
                    var index = _.findIndex(items, { id: id });
                    items.splice(index, 1);
                    model.trigger('render');
                });

        }
    });

    return FilterList;
});
